import { trackException } from "@/telemetry/appInsights";
import { api } from "@api/axiosInstance";
import { resetFilters } from "@app-redux/slices/filtersSlice";
import { resetProfileList } from "@app-redux/slices/profileListSlice";
import { resetUserData, setUnauthorized } from "@app-redux/slices/userDataSlice";
import { resetRepTop30 } from "@app-redux/slices/repTop30Slice";
import { resetOpportunity } from "@app-redux/slices/opportunitySlice";
import { ROUTER_PATHS } from "@/constants";
import { useAppDispatch } from "@app-redux/store";
import { useMsal } from "@azure/msal-react";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const queryClient = useQueryClient();

  const logout = async () => {
    if (window.location.pathname === `/${ROUTER_PATHS.signedOut}`) return;
    queryClient.clear();
    dispatch(resetUserData());
    dispatch(resetProfileList());
    dispatch(resetFilters());
    dispatch(resetRepTop30());
    dispatch(resetOpportunity());
    await instance.logoutRedirect();
  };

  useEffect(() => {
    const response = api.interceptors.response.use(
      (res) => res,
      async (error) => {
        trackException(error instanceof Error ? error : new Error(String(error)));
        if (error.response?.status === 401) {
          await logout();
        }
        if (error.response?.status === 403) {
          dispatch(setUnauthorized());
        }
        return Promise.reject(error);
      }
    );

    return () => {
      api.interceptors.response.eject(response);
    };
  }, []);
};
